import Aegis from "@tencent/aegis-web-sdk";

export const aegis = new Aegis({
    id: 2383, // 项目ID
    api: ["result", "err_code", "err_msg"]
});

export default {
    install(Vue) {
        Vue.config.errorHandler = function(err) {
            aegis.report(err);
            window.console && window.console.error(err);
        };
    }
};
